<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 checklistTempTab"
                    :data="contract_tab"
                    :query-param="{id:$route.params.id}"
                    activeKey="maintainence_program"
                    arrows >
                    <template slot="gofixTab:maintainence_program">
                        <gofix-card fullContent class="mb-0">
                            <gofix-default-table :settings="tableConfig"
                                :table-items="tableItems"
                                @new-item="openCreateItem"
                                @load-items="getTableData"
                                @row-click="openCreateItem"
                                @import-items="importItems"
                                @delete-items="deleteItems"
                                @clone-master="modals.clone.open = true"
                                ref="gofixTable">
                                <template slot="gofix_table:schedule" slot-scope="row">
                                    <router-link class="text-dark" :to="`/v2/contract-client/${$route.params.id}/maintenance-program/${row.item.id}?tab=maint_schedule`">
                                        <span class="text-decoration-underline">View</span>
                                    </router-link>
                                </template>
                                <template slot="gofix_table:name_checklist_templates" slot-scope="row">
                                <template v-if="row.item.contract_term">
                                    <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.contract_term.contract_id}/checkList-template/${row.item.checklist_template_id}`">
                                        <span class="text-decoration-underline">{{ row.item.name_checklist_templates }}</span>
                                    </router-link>
                                </template>
                                     <span class="text-decoration-underline" v-else>{{ row.item.name_checklist_templates }}</span>
                                </template>
                                <template slot="gofix_table:unit_price" slot-scope="row">
                                    {{ row.item.unit_price | formatMoney }}
                                </template>
                            </gofix-default-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>

        <b-modal :no-close-on-backdrop="true"
            id="modal-create-item"
            modal-class="modal-create"
            title="Create new maintenance program"
            hide-footer :centered="true"
            @hidden="resetModalCreateItem"
            ref="modal-create-item" v-model="modals.create.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="PM code" v-model="sorItem.sor_code"></gofix-form-input>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input label="Description" v-model="sorItem.description_one"></gofix-form-input>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-properties
                            label="Property"
                            :contract-id="$route.params.id"
                            search-nested
                            v-model="sorItem.location_info"
                            valueFormat="object">
                        </gofix-form-properties>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-tree
                            label="Service Category"
                            :default-expand-level="1"
                            :multiple="false"
                            :options="modals.create.dataService"
                            :load-options="loadOptionsService"
                            :normalizer="normalizerService"
                            search-nested
                            valueFormat="object"
                            v-model="sorItem.service_category"
                            placeholder="Select"
                            ref="input">
                        </gofix-form-tree>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-tree
                            label="Equipment Group"
                            :default-expand-level="1"
                            :multiple="false"
                            :options="modals.create.dataEquipment"
                            :load-options="loadOptionsEquiment"
                            :normalizer="normalizerEquipment"
                            search-nested
                            valueFormat="object"
                            v-model="sorItem.equipment_structure_type"
                            placeholder="Select"
                            ref="equipmentTree">
                        </gofix-form-tree>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-dropdown
                            label="Frequency"
                            desc="To create “Frequency” click MORE"
                            vLabel="recurring_mode"
                            :clearable="false"
                            :filterable="false"
                            :required="true"
                            :append-to-body="true"
                            :reduce="option => option.id"
                            v-model="sorItem.sor_recurring_mode_id"
                            :options="modals.create.dataRecurring">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-number label="Tolerance Period" v-model="sorItem.tolerance_period" desc="Days"></gofix-form-input-number>
                    </b-col>
                    <b-col md="12" class="mt-3">
                        <gofix-form-dropdown
                            label="Checklist template"
                            vLabel="name_checklist_templates"
                            :clearable="false"
                            :filterable="false"
                            :required="true"
                            :append-to-body="true"
                            :reduce="option => option.id"
                            v-model="sorItem.checklist_template_id"
                            :options="modals.create.dataChecklist">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="MORE" @click="goToDetai" noBorder dark></gofix-button>
                <gofix-button label="APPLY" :disabled="$disabledCreateOrUpdate(this.sorItem, $accessModule.maintenance_program)" @click="updateItemQuestion" :loading="modals.create.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
            id="modal-Clone"
            modal-class="default-modal clone-master"
            title="Copy from maintanence standard"
            size="xl"
            hide-footer :centered="true"
            v-model="modals.clone.open">
            <master-clone @close-modal="closeModalClone" :contractId="rootIds.contract_id" :contractTermId="rootIds.contract_term_id"></master-clone>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import {LOAD_CHILDREN_OPTIONS} from '@riophae/vue-treeselect'
    const MasterClone = () => import("./clone-master")

    import tabData from '@/data/_tabs';
    import { filters } from '@/_filterVar.js';

    import moment from 'moment';
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }

    export default {
        name: 'maintenance',
        components: {
            MasterClone
        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
            filter.is_maintenance.value = true;
            return {
                contract_tab: tabData.client_contract,
                tableConfig:{
                    name: 'maintenance-program',
                    controls:{
                        tableCloneMaster: true,
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "sor_code",
                    sortDirection: "asc",
                },
                tableItems: [],
                rootIds:{ // Root id from contract term
                    contract_id : this.$route.params.id,
                    contract_term_id: null
                },
                modals: {
                    create: {
                        open: false,
                        loading: false,
                        timer: null,
                        data: {},
                        checking:false,
                        dataService : [],
                        dataEquipment : [],
                        dataChecklist : [],
                        dataRecurring : []
                    },
                    clone: {
                        open: false
                    }
                },
            }
        },
        created () {
            //Get root data
            if(this.ClientContractID && this.ClientContractID.contract_terms){
                this.rootIds.contract_term_id = this.ClientContractID.contract_terms[0].id;
                this.rootIds.contract_id = this.ClientContractID.id;
            }

            this.getDataEquipment(0, this.rootIds.contract_id, 'all',true);
            this.getDataChecklist();
            this.getDataRecurring();
            this.getDataService(0, this.rootIds.contract_id, 'all',true);
        },
        computed: {
            ...mapGetters({
                sorItem:  'v2SorController/sorItem',
            })
        },
        watch: {
            ClientContractID: function(val, old){
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }

                if(val) {
                    this.rootIds.contract_term_id = val.contract_terms[0].id;
                    this.rootIds.contract_id = val.id;
                }

                if(old && val && old.id && val.id && old.id != val.id) {
                    this.getDataEquipment(0, val.id, 'all',true);
                    this.getDataChecklist();
                    this.getDataRecurring();
                    this.getDataService(0, val.id, 'all',true);
                }
            },
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("v2SorController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the maintenance program", "danger");
                    reject();
                })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("v2SorController/deleteItem", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'maintenance_program'));
                })
                .catch(err =>{
                    reject(err);
                });
            },
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`v2SorController/importMaintenance`, {
                    fileImportSOR: file,
                    id : this.rootIds.contract_term_id
                })
                .then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'maintenance_program');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
            /*---- Get Data -------*/
            async getDataEquipment(parent_id, contract_id, node_type,set = false){
                let dataE = [];
                await global.axios(`api/equipment/tree-structure/${parent_id}`, {
                    method: "GET",
                    params: {
                        contract_id: contract_id,
                        node_type: node_type
                    },
                    headers: { Accept: "application/json", }
                })
                .then(response => {
                    dataE = response.data.data;
                }).catch(error => {});

                if(set) {
                    this.modals.create.dataEquipment = dataE;
                } else {
                    return dataE
                }
            },
            async getDataService(parent_id,contract_id,node_type,set = false){
                let data = [];
                await  this.$store.dispatch("v2SorController/getService",{
                    contract_id: this.rootIds.contract_id,
                    service_id: parent_id
                })
                .then( response => {
                    data = response;
                })
                .catch( err => {
                    data = [];
                });

                if(set) {
                    this.modals.create.dataService = data;
                } else {
                    return data
                }
            },
            async getDataRecurring(){
                this.$store.dispatch('SorRecurringModesController/getListSorRecurringModes')
                .then(response => {
                    this.modals.create.dataRecurring =  response.data.data
                })
                .catch(err => {
                    this.modals.create.dataRecurring = [];
                })
            },
            async getDataChecklist(){
                this.$store.dispatch( 'v2CheckListTemplateController/searchTemplate', [
                  1000, 1, {contract_id: this.rootIds.contract_id}
                ])
                .then(response => {
                    this.modals.create.dataChecklist = response.data.data.items;
                })
                .catch(err => {
                    this.modals.create.dataChecklist = [];
                });
            },

            /*---------------------------*/

          /*----- Save data ----------------------*/
            updateItemQuestion(){
                this.sorItem.unit_price = this.$accounting.unformat(this.sorItem.unit_price_tmp);
                this.sorItem.is_maintenance = true;
                if(!this.sorItem.sor_code
                    || !this.sorItem.service_category
                    || !this.sorItem.sor_recurring_mode_id
                    || !this.sorItem.checklist_template_id
                ) {
                    this.$alertNotification("Please enter in all the fields", "danger");
                    return false;
                }
                if(this.sorItem.id) {
                    this.$bvModal.msgBoxConfirm('Related schedule and related job list will delete. Are you sure to update?', {
                        title: 'Notification!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'OK',
                        cancelTitle: 'CANCEL',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    })
                    .then(value => {
                        if(value){
                          this.saveData();
                        }
                    })
                } else {
                    this.saveData();
                }
            },
            saveData(){
                 if (this.modals.create.timer) {
                    clearTimeout(this.modals.create.timer);
                    this.modals.create.timer = null;
                }
                this.modals.create.timer = setTimeout(() => {
                    if(this.modals.create.loading) return;
                    this.modals.create.loading = true;

                    let keyMessage= 'adding'
                    if(this.sorItem.id) {
                        keyMessage = 'editing'
                    }

                    this.$store.dispatch("v2SorController/saveSorItem",this.rootIds.contract_term_id).then( data => {
                        this.$alertNotification(this.$notificationV2(keyMessage, 'maintenance_program'));
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.modals.create.loading = false;
                        this.modals.create.open    = false;
                    }).catch(err => {
                        this.modals.create.loading = false;
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    });
                }, 300);
            },
            closeModalClone(flag = false){
                if( flag ) {
                    this.$alertNotification("Successfully added maintenance program");
                }
                this.modals.clone.open = false;
                this.$refs.gofixTable.reloadTableItems();
            },
            /*---------------------------*/
            goToDetai(){
                let id = this.sorItem.id || 0;
                return this.$router.push(`/v2/contract-client/${this.$route.params.id}/maintenance-program/${id}`);
            },
            resetModalCreateItem(){
                this.$store.commit("v2SorController/setItem",null);
            },
            async openCreateItem(item){
                if(!item){
                    await this.$store.commit("v2SorController/setItem",null);
                    //pre-fill PM-code with a unique ID
                    this.sorItem.sor_code = "PM-CODE-" + moment().format("DDMMYY-ssSSS");
                    await this.checkExistCode(this.sorItem.sor_code);
                    while (this.modals.create.checking) {
                        this.sorItem.sor_code = "PM-CODE-" + moment().format("DDMMYY-ssSSS");
                        await this.checkExistCode(this.sorItem.sor_code);
                    }
                    this.modals.create.open = true;
                } else {
                    this.$router.push(`/v2/contract-client/${this.$route.params.id}/maintenance-program/${item.id}`);
                }
            },
            checkExistCode(val){
                if(val) {
                    this.modals.create.checking = false;
                    global.axios.get(`api/sor/check-existing`, {
                        params: {
                            sor_code: val,
                            contract_id: this.rootIds.contract_id
                        }
                    })
                    .then(response => {
                        this.modals.create.checking = response.data.data.existing;
                    })
                    .catch(error => {
                        this.modals.create.checking = true;
                    });
                }
            },
            loadOptionsService({ action, parentNode, callback,instanceId  }){
                if (action === LOAD_CHILDREN_OPTIONS ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getDataService(parentNode.data.id,this.rootIds.contract_id,'all');
                        callback()
                    })
                }
            },
            normalizerService(node) {
                if(node.data && !node.data.isBatch){
                    return {
                        children : undefined,
                        label: node.name
                    }
                }
                return {
                    label: node.name
                }
            },
            loadOptionsEquiment({ action, parentNode, callback }) {
                if (action === LOAD_CHILDREN_OPTIONS ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getDataEquipment(parentNode.data.id,this.rootIds.contract_id,'all');
                        callback()
                    })
                }
            },
            normalizerEquipment(node) {
                if(node.data && node.data.isBatch) {
                    return {
                        id: node.data.id,
                        label: node.data.name,
                        children: node.children
                    }
                }
                return {
                    id: node.id,
                    label: node.name,
                    children: undefined
                }
            }
        }
    }
</script>